import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NotificationModel } from '@app/models/failure/notification.model';
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  public modelNotifications: NotificationModel[];
  public modelFaultPreviousPage: any;
  public placeIdPreviousPage: number = 0;
  public showRuleContent: boolean = false;
  public buttonName: any = 'Hide All';

  hideme = [];
  count: number;
  isShowContainer: boolean;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private _snackRef: MatSnackBarRef<NotificationComponent>,
    private _dialog: MatDialog) { }

  ngOnInit(): void {
    this.modelFaultPreviousPage = this.data.modelFault || this.modelFaultPreviousPage;
    this.placeIdPreviousPage = this.data.placeId || this.placeIdPreviousPage;
    this.modelNotifications = this.data.modelNotifications || this.modelNotifications;
    this.count = this.modelNotifications?.length;
    if (this.modelNotifications.length === 0) { this._snackRef.dismiss(); }
  }
  toggle(event) {
    this.showRuleContent = !this.showRuleContent;
    this.buttonName = this.showRuleContent ? "Show All" : "Hide All";
  }

  onBack() {
    this._snackRef.dismiss();
  }

}